import { gql } from '@apollo/client';

export const ADD_VEHICLE_ALERT = gql`
  mutation addVehicleAlert($input: AddVehicleAlertInput!) {
    addVehicleAlert(input: $input) {
     __typename
     vehicleUuid
     vehicleAlertUuid
     vehicleAlert {
      alertType {
        __typename
        id
        name
        alertLevel
        position
        oriId
      }
      expireAt
      id
      notes
      officerId
     }
     clientMutationId
     errors
    }
  }
`